import script from "./basicInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./basicInfo.vue?vue&type=script&lang=ts&setup=true"

import "./basicInfo.vue?vue&type=style&index=0&id=09824ec2&lang=css"

const __exports__ = script;

export default __exports__